/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessedItemType } from './assessedItemType';


export interface ImportAssessedRecordApiModel { 
    capabilityDefinitionId: number;
    validSince: string;
    validUntil: string;
    itemType: AssessedItemType;
}
export namespace ImportAssessedRecordApiModel {
}


